import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  shopUserList: [],
};

export const shopUserSlice = createSlice({
  name: "shopUser",
  initialState,
  reducers: {
    updateShopUserList(state, action) {
      state.shopUserList = action.payload.shopUserList;
    },
    resetShopUserSlice: (state) => initialState,
  },
});
export const shopUserActions = shopUserSlice.actions;
export default shopUserSlice.reducer;
